export default {
  operatedBy: 'Operado por',
  partlyOperatedBy: 'Parcialmente operado por',
  operatedByGerman: '',
}
